import React, {useState, useCallback, useEffect} from 'react';
import HappyArrowDropIcon from '@stencil/icons/src/HappyArrowDropIcon/HappyArrowDropIcon';
import {defaultTheme} from '@stencil/build-theme';
import * as S from './Faqs.styles';

const MAX_VISIBLE_FAQS = 3;

const FaqItem = ({faq, openModal, idx, searchInput = ''}) => {
  const [isAnswerVisible, setAnswerVisible] = useState((idx === 0 && !openModal) || false);

  useEffect(() => {
    if (openModal) {
      setAnswerVisible(openModal && !!searchInput);
    }
  }, [openModal, searchInput]);

  const handleToggle = useCallback(() => {
    setAnswerVisible(prev => !prev);
  }, []);

  return (
    <S.QuestionAnswerWrapper $$ShowElement={idx < MAX_VISIBLE_FAQS || openModal}>
      <S.QuestionsWrapper onClick={handleToggle}>
        <S.QuestionText>{faq.question}</S.QuestionText>
        <HappyArrowDropIcon
          rotateReverse={isAnswerVisible}
          className="arrowDown"
          fill={defaultTheme?.colors?.goBrandBlue?.base}
          data-testid={`faq-arrow-${idx}`}
        />
      </S.QuestionsWrapper>
      <S.AnswerText $$ShowAnswer={isAnswerVisible}>{faq.answer}</S.AnswerText>
    </S.QuestionAnswerWrapper>
  );
};

export default FaqItem;
